import { render, staticRenderFns } from "./UpdatePatientService.vue?vue&type=template&id=39937bc2&"
import script from "./UpdatePatientService.vue?vue&type=script&lang=js&"
export * from "./UpdatePatientService.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePatientService.vue?vue&type=style&index=0&id=39937bc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports